import axios from 'axios';
import Vue from 'vue';
import i18n from '@/plugins/i18n';
import { eventHub } from '@/mixins/event';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import router from './router';
import store from './store';
import C from '@/components/C.vue';
import c from '@/mixins/contents.js';

Vue.prototype.$http = axios;
axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  config.headers.common['Accept-Language'] = i18n.locale;
  const token = VueCookies.get('csrftoken');
  if (token) {
    config.headers['x-csrftoken'] = token;
  }
  return config;
});
axios.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response.status === 403) {
      eventHub.$emit('modal:login:open');
    }
    return Promise.reject(error);
  },
);

Vue.config.productionTip = false;

Vue.use(VueCookies);

new Vue({
  router,
  store,
  i18n,
  mixins: c,
  render: h => h(App),
}).$mount('#app');

Vue.component('c', C);
